import { useCallback, useState } from 'react';

import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

const DISMISS_KEY = (pageId: string) => `cfind-polish-banner-dismissed-${pageId}`;

/**
 * Returns the dismissal state and a dismiss callback for the ImportedPagePolishBanner.
 * Dismissal is persisted per-page in localStorage so the banner doesn't re-appear
 * after the user has dismissed it.
 */
export const usePolishBannerDismissal = (
	pageId: string,
): { dismissed: boolean; dismiss: () => void } => {
	const [dismissed, setDismissed] = useState<boolean>(() => {
		return confluenceLocalStorageInstance?.getItemAsBoolean(DISMISS_KEY(pageId)) ?? false;
	});

	const dismiss = useCallback(() => {
		confluenceLocalStorageInstance?.setItem(DISMISS_KEY(pageId), true);
		setDismissed(true);
	}, [pageId]);

	return { dismissed, dismiss };
};
